import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/lib/currency";

function StatusBadge({ p }) {
  const { t } = useTranslation();
  if (p.ico_id) {
    return <Badge className="rounded-none bg-black font-mono-label text-[10px] shrink-0">{t("ll_status_ico_live")}</Badge>;
  }
  if (p.amc_id) {
    return <Badge className="rounded-none bg-[#FFCC00] text-black font-mono-label text-[10px] shrink-0">{t("ll_status_awaiting")}</Badge>;
  }
  return <Badge className="rounded-none bg-[#FF3B30] font-mono-label text-[10px] shrink-0">{t("ll_status_needs_amc")}</Badge>;
}

export default function PropertyCard({ property: p, onAssignAmc, onAssignTenant }) {
  const { t } = useTranslation();
  const { fmt } = useCurrency();

  return (
    <div className="border border-black/10 bg-white overflow-hidden">
      <div className="grid grid-cols-3">
        <div className="aspect-square">
          <img src={p.image_url} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="col-span-2 p-5 min-w-0">
          <div className="flex justify-between items-start gap-2">
            <div className="min-w-0">
              <div className="font-display text-xl font-bold truncate">{p.name}</div>
              <div className="text-xs text-zinc-500 mt-1 truncate">{p.address}</div>
            </div>
            <StatusBadge p={p} />
          </div>

          <div className="grid grid-cols-3 gap-px bg-black/10 mt-4">
            <div className="bg-white p-2 min-w-0">
              <div className="font-mono-label text-[9px] text-zinc-500 truncate">{t("ll_units")}</div>
              <div className="font-display text-base font-bold tabular-nums">{(p.units || []).length || 1}</div>
            </div>
            <div className="bg-white p-2 min-w-0">
              <div className="font-mono-label text-[9px] text-zinc-500 truncate">{t("ll_agg_rent")}</div>
              <div className="font-display text-base font-bold tabular-nums truncate">{fmt(p.monthly_rent)}</div>
            </div>
            <div className="bg-white p-2 min-w-0">
              <div className="font-mono-label text-[9px] text-zinc-500 truncate">{t("ll_amc")}</div>
              <div className="text-xs truncate">{p.amc_name || "—"}</div>
            </div>
          </div>

          <div className="flex gap-2 mt-4 flex-wrap">
            {!p.amc_id && (
              <Button
                data-testid={`assign-amc-${p.id}`}
                onClick={() => onAssignAmc(p)}
                className="rounded-none h-9 bg-[#002FA7] hover:bg-[#001F70] font-mono-label text-[10px]"
              >
                {t("ll_delegate_amc")}
              </Button>
            )}
            {!p.tenant_id && (
              <Button
                data-testid={`assign-tenant-${p.id}`}
                onClick={() => onAssignTenant(p)}
                variant="outline"
                className="rounded-none h-9 border-black font-mono-label text-[10px]"
              >
                {t("ll_assign_tenant")}
              </Button>
            )}
            {p.ico_id && (
              <Link to={`/ico/${p.ico_id}`}>
                <Button variant="outline" className="rounded-none h-9 border-black font-mono-label text-[10px]">
                  {t("ll_view_ico")}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
